import React, { useState, useRef } from 'react';
import { Box, TextField, Button, Paper, CircularProgress } from '@mui/material';
import { UseApi } from '../Hooks/UseApi'; // Import the UseApi hook

const AddInventoryPage = () => {
  // Use our API hook instead of direct axios calls
  const api = UseApi();
  // Use useRef to stabilize API references to prevent infinite re-renders
  const apiRef = useRef(api);
  
  const [formData, setFormData] = useState({ name: '', quantity: 0, price: 0, description: '' });
  const [loading, setLoading] = useState(false);
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Use apiRef.current.addInventoryItem method
      await apiRef.current.addInventoryItem(formData);
      alert('Inventory item added successfully!');
      // Reset form
      setFormData({ name: '', quantity: 0, price: 0, description: '' });
    } catch (error) {
      alert(`Failed to add inventory item: ${error.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Box sx={{ p: 4 }}>
      <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
        <form onSubmit={handleSubmit}>
          <TextField
            name="name"
            label="Name"
            fullWidth
            margin="normal"
            value={formData.name}
            onChange={handleInputChange}
          />
          <TextField
            name="quantity"
            label="Quantity"
            fullWidth
            margin="normal"
            type="number"
            value={formData.quantity}
            onChange={handleInputChange}
          />
          <TextField
            name="price"
            label="Price"
            fullWidth
            margin="normal"
            type="number"
            value={formData.price}
            onChange={handleInputChange}
          />
          <TextField
            name="description"
            label="Description"
            fullWidth
            margin="normal"
            multiline
            rows={4}
            value={formData.description}
            onChange={handleInputChange}
          />
          <Button
            variant="contained"
            color="primary"
            type="submit"
            sx={{ mt: 2 }}
            fullWidth
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Add Inventory'}
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default AddInventoryPage;